import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { ChevronDown, ChevronUp } from '$lib/icons';

var root_4 = $.from_html(`<div class="flex items-center justify-between text-sm py-1"><span class="text-muted-foreground"> </span> <div class="flex items-center gap-3"><span class="text-muted-foreground font-mono text-xs"> </span> <span class="font-medium text-foreground font-mono"> </span></div></div>`);
var root_3 = $.from_html(`<div class="mt-4 pt-4 border-t space-y-2"><h4 class="text-sm font-semibold text-foreground mb-2">Share Breakdown</h4> <!> <div class="flex items-center justify-between text-sm pt-2 border-t font-semibold"><span class="text-foreground">Total</span> <span class="text-foreground font-mono"> </span></div></div>`);
var root = $.from_html(`<button type="button" class="w-full text-left p-3 border rounded-lg hover:bg-secondary/50 transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"><div class="flex items-center justify-between"><div class="flex-1 min-w-0 mr-3"><p class="font-medium text-foreground truncate"> </p> <p class="text-sm text-muted-foreground"> </p></div> <div class="flex items-center gap-3"><div class="text-right shrink-0"><p class="font-medium text-foreground"> </p> <span class="text-xs px-2 py-1 rounded bg-secondary text-secondary-foreground"> </span></div> <div class="shrink-0"><!></div></div></div> <!></button>`);

export default function ExpenseCard($$anchor, $$props) {
	$.push($$props, true);

	let expanded = $.prop($$props, 'expanded', 3, false);

	function formatCurrency(amount) {
		return new Intl.NumberFormat('en-IE', {
			style: 'currency',
			currency: 'EUR',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(amount);
	}

	function formatSplitMode(mode) {
		switch (mode) {
			case 'BY_NIGHT':
				return 'By Night';

			case 'BY_SHARE':
				return 'By Members';

			case 'EQUAL':
				return 'Equal';

			case 'FREE':
				return 'Free';

			default:
				return mode;
		}
	}

	function getPayerName() {
		return $$props.split.participants.find((p) => p.id === $$props.expense.payerId)?.name || 'Unknown';
	}

	function getParticipantName(participantId) {
		return $$props.split.participants.find((p) => p.id === participantId)?.name || participantId;
	}

	function formatShareCalculation(participantId) {
		const participant = $$props.split.participants.find((p) => p.id === participantId);

		if (!participant) return '';

		if ($$props.expense.splitMode === 'BY_NIGHT') {
			const totalNights = $$props.split.participants.reduce((sum, p) => sum + p.nights, 0);

			return `${participant.nights}/${totalNights} nights`;
		} else if ($$props.expense.splitMode === 'EQUAL') {
			return 'Split equally';
		} else if ($$props.expense.splitMode === 'FREE') {
			return 'Manual split';
		}

		return '';
	}

	function toggleExpanded() {
		if ($$props.onToggle) {
			$$props.onToggle();
		}
	}

	var button = root();

	button.__click = toggleExpanded;

	var div = $.child(button);
	var div_1 = $.child(div);
	var p_1 = $.child(div_1);
	var text = $.child(p_1, true);

	$.reset(p_1);

	var p_2 = $.sibling(p_1, 2);
	var text_1 = $.child(p_2);

	$.reset(p_2);
	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var div_3 = $.child(div_2);
	var p_3 = $.child(div_3);
	var text_2 = $.child(p_3, true);

	$.reset(p_3);

	var span = $.sibling(p_3, 2);
	var text_3 = $.child(span, true);

	$.reset(span);
	$.reset(div_3);

	var div_4 = $.sibling(div_3, 2);
	var node = $.child(div_4);

	{
		var consequent = ($$anchor) => {
			ChevronUp($$anchor, { class: 'h-5 w-5 text-muted-foreground' });
		};

		var alternate = ($$anchor) => {
			ChevronDown($$anchor, { class: 'h-5 w-5 text-muted-foreground' });
		};

		$.if(node, ($$render) => {
			if (expanded()) $$render(consequent); else $$render(alternate, false);
		});
	}

	$.reset(div_4);
	$.reset(div_2);
	$.reset(div);

	var node_1 = $.sibling(div, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_5 = root_3();

			div_5.__click = (e) => e.stopPropagation();

			var node_2 = $.sibling($.child(div_5), 2);

			$.each(node_2, 17, () => $$props.expense.shares, $.index, ($$anchor, share) => {
				var div_6 = root_4();
				var span_1 = $.child(div_6);
				var text_4 = $.child(span_1, true);

				$.reset(span_1);

				var div_7 = $.sibling(span_1, 2);
				var span_2 = $.child(div_7);
				var text_5 = $.child(span_2, true);

				$.reset(span_2);

				var span_3 = $.sibling(span_2, 2);
				var text_6 = $.child(span_3, true);

				$.reset(span_3);
				$.reset(div_7);
				$.reset(div_6);

				$.template_effect(
					($0, $1, $2) => {
						$.set_text(text_4, $0);
						$.set_text(text_5, $1);
						$.set_text(text_6, $2);
					},
					[
						() => getParticipantName($.get(share).participantId),
						() => formatShareCalculation($.get(share).participantId),
						() => formatCurrency($.get(share).amount)
					]
				);

				$.append($$anchor, div_6);
			});

			var div_8 = $.sibling(node_2, 2);
			var span_4 = $.sibling($.child(div_8), 2);
			var text_7 = $.child(span_4);

			$.reset(span_4);
			$.reset(div_8);
			$.reset(div_5);
			$.template_effect(($0) => $.set_text(text_7, `${$0 ?? ''} ✓`), [() => formatCurrency($$props.expense.amount)]);
			$.append($$anchor, div_5);
		};

		$.if(node_1, ($$render) => {
			if (expanded()) $$render(consequent_1);
		});
	}

	$.reset(button);

	$.template_effect(
		($0, $1, $2) => {
			$.set_attribute(button, 'aria-expanded', expanded());
			$.set_text(text, $$props.expense.description);
			$.set_text(text_1, `Paid by ${$0 ?? ''}`);
			$.set_text(text_2, $1);
			$.set_text(text_3, $2);
		},
		[
			getPayerName,
			() => formatCurrency($$props.expense.amount),
			() => formatSplitMode($$props.expense.splitMode)
		]
	);

	$.append($$anchor, button);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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